import React, { Fragment } from 'react'
import axios from 'axios'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { actualizaCliente, actualizarDatosFilesCliente, actualizarFileCliente, agregarFileCliente, agregarHistorialArchivosCliente, obtenerClienteConDetalle } from '../../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import moment from 'moment'
import estilos from '../../../TablaClientesComponent.module.css'

import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../../redux/AppDucks'
function BotonSustituirComponent(props) {

    const dispatch = useDispatch()
    const file = useSelector(store => store.ModuloConsulta.file)
    const dataUser = useSelector(store => store.Usuario.user)
    const detalleCliente = useSelector(store => store.ModuloConsulta.detalleCliente)

    const [openModalSustituir, setOpenModalSustituir] = React.useState(true);
    const [observaciones, setObservaciones] = React.useState(props?.data?.observacion)
    const [vigencia, setVigencia] = React.useState(false);
    const [estadoVigencia, setEstadoVigencia] = React.useState(props?.data?.estatus == "null" ? 'Agregar' : props?.data?.estatus)
    //const [fechaInicio, setFechaInicio] = React.useState(props.data.fechaInicio == '---' ? '' : moment(props.data.fechaInicio).format('YYYY-MM-DD'))
    //const [fechaTermino, setFechaTermino] = React.useState(props.data.fechaTermino == '---' ? '' : moment(props.data.fechaTermino).format('YYYY-MM-DD'))
    const [fechaInicio, setFechaInicio] = React.useState(props.data.fechaInicio == '---' ? '' : props.data.fechaInicio)
    const [fechaTermino, setFechaTermino] = React.useState(props.data.fechaTermino == '---' ? '' : props.data.fechaTermino)

    const [opciondom, setopciondom] = React.useState(props?.data?.nameDoc == 'Denominación de origen' ? detalleCliente?.opciondom : '')
    const [numerodom, setnumerodom] = React.useState(props?.data?.nameDoc == 'Denominación de origen' ? detalleCliente?.numerodom : '')

    const styleSustituir = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: 'fit-content',
        bgcolor: 'background.paper',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black',
        borderRadius: '5px'
    };


    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const handleOpenModalSustituir = () => {
        setOpenModalSustituir(true)
    }
    const handleCloseModalSustituir = async () => {
        setOpenModalSustituir(false)
        setObservaciones('')
        setnumerodom('')
        setopciondom('')
        props.setOpenModalSustituir(false)
    }
    const handdleFile = async (objectFile) => {
           await dispatch(actualizarLoadingApp_true())
        let JSONFile = []
        let data = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        if (props?.data.tabla == 'archivosgeneralescliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idSolicitud, file: objectFile, idAnexoFK: props?.idcliente }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivosCliente' }
        }
        if (props?.data.tabla == 'archivosapoderadoslegalescliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivoRepresentanteLegalCliente' }
        }
        if (props?.data.tabla == 'archivospersonasautorizadascliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivosPersonaAutorizadaCliente' }
        }
        if (props?.data.tabla == 'archivospredioscliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivosPredioCliente' }
        }
        if (props?.data.tabla == 'archivosviveroscliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivoViverosCliente' }
        }
        if (props?.data.tabla === 'archivosinstalacionescliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivoInstalacionCliente' }
        }
        if (props?.data.tabla === 'archivosresposansablescliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivoResponsableInstalacionCliente' }
        }
        if (props?.data.tabla == 'archivosmarcascliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivoMarcaCliente' }
        }
        if (props?.data.tabla == 'archivosmarcasproductocliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'InformacionValida/actualizarArchivoMarcaProductoCliente' }
        }
        if (props?.data.tabla == 'oficioscliente') {
            JSONFile = { id: props?.data?.nameid, idAnexo: props?.data?.idAnexo, file: objectFile, idAnexoFK: props?.data?.idSolicitud }
            data = { archivo: JSONFile, ruta: 'ModuloConsulta/actualizarOficiosCliente' }
        }
        let result = await dispatch(actualizarFileCliente(data))


        let fechahistorial = new Date(fechaHoy).toISOString()
        let dataHistorial = {}
        if (props?.data.tabla == 'archivosgeneralescliente') dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosgeneralescliente, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivosapoderadoslegalescliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosapoderadoscliente, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivospersonasautorizadascliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivospersonasatutorizadascliente, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivospredioscliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivospredio, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivosviveroscliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosvivero, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivosinstalacionescliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosinstalacion, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivosresposansablescliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosresponsables, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivosmarcascliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosmarca, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'archivosmarcasproductocliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idarchivosmarcaproducto, tabla: props?.data?.tabla
        }
        if (props?.data.tabla == 'oficioscliente' && result?.payload?.data?.data) dataHistorial = {
            usuario: dataUser?.[0]?.usuario, fecha: fechahistorial, nombrearchivo: objectFile.name,
            idarchivo: result?.payload?.data?.data?.idoficioscliente, tabla: props?.data?.tabla
        }
        await dispatch(agregarHistorialArchivosCliente(dataHistorial))
        await dispatch(actualizarLoadingApp_false())

        //await dispatch(obtenerClienteConDetalle(props?.idcliente))
    }
    const guardarDatosArchivos = async () => {
        //if (file?.length > 0) {
        let fechaI = null
        if (fechaInicio != '') {
            fechaI = new Date(fechaInicio).toISOString()
        }
        let fechaF = null
        if (fechaTermino != '') {
            fechaF = new Date(fechaTermino).toISOString()
        }

        let dataArchivo = {}
        if (props?.data?.tabla == 'archivosgeneralescliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idSolicitud,
                nombreid: 'idarchivosgeneralescliente', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivosapoderadoslegalescliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivosapoderadoscliente', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivospersonasautorizadascliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivospersonasatutorizadascliente', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivospredioscliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivospredio', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivosviveroscliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivosvivero', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivosinstalacionescliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivosinstalacion', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivosresposansablescliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivosresponsables', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivosmarcascliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivosmarca', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }
        if (props?.data?.tabla == 'archivosmarcasproductocliente') {
            dataArchivo = {
                fechainicio: fechaI, fechafin: fechaF, observaciones: observaciones, id: props?.data?.idAnexo,
                nombreid: 'idarchivosmarcaproducto', tabla: props?.data?.tabla, estatus: estadoVigencia, isdocumentovalido: props?.data?.isDocumentoValido
            }
        }

        if (props?.data?.nameDoc == 'Denominación de origen') {
            const fechaHoy = moment().format('YYYY-MM-DD')
            let fechacambio= new Date(fechaHoy).toISOString()
            let dataValida = {
                datacambio: {
                    idcliente: detalleCliente.idcliente, opciondom: opciondom, numerodom: numerodom
                }, idcliente: detalleCliente.idcliente, usuariocambio: dataUser?.[0]?.usuario, fechacambio: fechacambio
            }
            await dispatch(actualizaCliente(dataValida))
        }
        //setNombreArchivo('')
        setVigencia(false)
        setObservaciones('')
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setnumerodom('')
        setopciondom('')
        await dispatch(actualizarDatosFilesCliente(dataArchivo))
        props.setOpenModalSustituir(false)
        //}
        await dispatch(obtenerClienteConDetalle(props?.idcliente))
    }
    const botonVigencia = () => {
        setVigencia(true)
    }
    const botonCerrarVigencia = () => {
        obtenerVigencia()
        setVigencia(false)
    }
    const obtenerVigencia = () => {

        let bandera = false
        let fecha1 = new Date(fechaTermino)
        let fecha2 = new Date(moment().format('YYYY-MM-DD'))

        let milisegundosDia = 24 * 60 * 60 * 1000
        let milisegundosTrascurridos = Math.abs(fecha1.getTime() - fecha2.getTime())
        let diasTranscurridos = Math.round(milisegundosTrascurridos / milisegundosDia)
        let milisegundos = fecha1.getTime() - fecha2.getTime()
        if (milisegundos > 0 || milisegundos === NaN) {
            setEstadoVigencia('Vigente')
        } else {
            setEstadoVigencia('Vencido')
        }
        return bandera
    }
    return (
        <Fragment>
            <Modal
                open={openModalSustituir}
                onClose={handleCloseModalSustituir}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleSustituir}>
                    <Typography id="modal-modal-title" variant="h5" sx={{ mt: 0, fontFamily: 'Montserrat', textAlign: 'center', fontWeight: 'bold' }}>
                        Sustituir archivo
                    </Typography>
                    <Typography id="modal-modal-description" component="h5" sx={{ mt: 3, fontFamily: 'Montserrat' }} className='text-center'>
                        <input className={`form-control `} type="file" accept="application/pdf" onChange={e => handdleFile(e.target.files[0])}></input>
                        {props?.data?.tabla != 'oficioscliente' &&
                            <div className='row'>
                                <div className="form-floating mt-3">
                                    <input type="text" name="password" className='form-control' id="floatinginput"
                                        placeholder='observaciones' value={observaciones} onChange={e => { setObservaciones(e.target.value) }} />
                                    <label htmlFor="floatingInput">Observaciones</label>
                                </div>
                                {props?.data?.nameDoc == 'Denominación de origen' &&
                                    <div className='row mt-2'>
                                        <div className={`col-md-12 ${estilos.selectorFile} text-center`}>
                                            <div className="form-floating mb-2 text-center">
                                                <select className={`form-select form-select-sm`} value={opciondom} onChange={e => setopciondom(e.target.value)} >
                                                    <option value="">Seleccione una opción</option>
                                                    <option value="Autorizado">Autorizado</option>
                                                    <option value="En Trámite">En Trámite</option>
                                                    <option value="No Cuenta">No Cuenta</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='form-floating mb-3 col-md-12'>
                                            <input className={`form-control`}
                                                type="number"
                                                onChange={e => setnumerodom(e.target.value)}
                                                value={numerodom} id="numerosociocliente"
                                                name="numerosociocliente"
                                                onWheel={event => event.currentTarget.blur()}
                                                placeholder='numero'
                                            />
                                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                Número de Denominación de origen
                                            </label>
                                        </div>
                                    </div>}

                                {props.data.quitarVigencia == false &&
                                    <div className='row justify-content-center mt-3'>
                                        <div className="form-floating col-md-6">
                                            <input type="date" className={`form-control `} id="floatinginput" placeholder='Inicio'
                                                value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
                                            <label htmlFor="floatingInput"> Fecha inicio</label>
                                        </div>
                                        <div className="form-floating col-md-6">
                                            <input type="date" className={`form-control `} id="floatinginput" placeholder='Termino'
                                                value={fechaTermino} onChange={e => setFechaTermino(e.target.value)} />
                                            <label htmlFor="floatingInput">Fecha termino</label>
                                        </div>
                                    </div>
                                }
                            </div>
                        }

                    </Typography>
                    <ThemeProvider theme={theme}>
                        {props?.data?.tabla == 'oficioscliente' ?
                            <div className='row mt-5'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModalSustituir() }}>Cerrar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { handleCloseModalSustituir() }}>Guardar</Button>
                                </div>
                            </div>
                            :
                            <div className='row mt-5'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModalSustituir() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { guardarDatosArchivos() }}>Guardar</Button>
                                </div>
                            </div>
                        }

                    </ThemeProvider>
                </Box>
            </Modal>
        </Fragment>
    )
}

export default BotonSustituirComponent